/**
 * Logo.dev publishable key.
 *
 * Publishable by design — it ships in the client bundle — but it is NOT
 * unconditionally usable: Logo.dev restricts it to an allow-list of referring
 * domains. Browsers pass that check automatically via the `Referer` header.
 * Server-side `fetch` does not send one, so a backend request with this key
 * fails with `401 invalid referrer` unless it sets `Referer` explicitly
 * (see getLogoFetchHeaders in services/prospects/manageTerms/GenerateTermSheet).
 */
export const LOGO_DEV_PUBLIC_KEY = 'pk_b0EtZx0aRYSiWNT-Tp0Uyw'

export const LOGO_DEV_IMAGE_HOST = 'img.logo.dev'
